import { EventEntityDefinition } from 'components/eventView/pages/eventData';
import { InfoCircle } from 'elements/eventView/atomic/InfoCircle';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import { Localization } from 'static/localization/localization';

interface IOverviewButtonProps {
    linkTo: string;
    number?: number;
    title: string;
    tileColor: string;
    infoCircle: React.ReactNode;
}

export const useButtonDefinitions = () => {
    const ctxEventView = useContext(CtxEventView);
    const { eventData, eventPath } = ctxEventView;

    const programme: IOverviewButtonProps = {
        linkTo: `/event/${eventPath}/program`,
        number: eventData.eventInfo.program?.items?.length || 0,
        title: ctxEventView.programTitleShort,
        tileColor: eventData.eventInfo.styling.tileColor,
        infoCircle: (
            <InfoCircle
                icon={{
                    iconPrefix: 'far',
                    iconName: 'clock'
                }}
                bgColor={eventData.eventInfo.styling.circle.bgColor}
                iconColor={eventData.eventInfo.styling.circle.iconColor}
            />
        )
    };

    const information: IOverviewButtonProps = {
        linkTo: `/event/${eventPath}/information`,
        number: eventData.eventInfo.information?.listIds.length || 0,
        title: Localization.INFO,
        tileColor: eventData.eventInfo.styling.tileColor,
        infoCircle: (
            <InfoCircle
                icon={{
                    iconPrefix: 'far',
                    iconName: 'circle-info'
                }}
                bgColor={eventData.eventInfo.styling.circle.bgColor}
                iconColor={eventData.eventInfo.styling.circle.iconColor}
            />
        )
    };

    const map = {
        title: Localization.INTERACTIVE_MAP,
        linkTo: `/event/${eventPath}/map`,
        number: ctxEventView.mapEntityState.all.length || 0,
        mapImageUrl: eventData.eventInfo.mapPreviewUrl,
        backgroundColor: eventData.eventInfo.styling.circle.bgColor,
        color: eventData.eventInfo.styling.circle.iconColor,
        tileColor: eventData.eventInfo.styling.tileColor,
        infoCircle: (
            <InfoCircle
                icon={{
                    iconPrefix: 'far',
                    iconName: 'location-dot'
                }}
                bgColor={eventData.eventInfo.styling.circle.bgColor}
                iconColor={eventData.eventInfo.styling.circle.iconColor}
            />
        )
    };

    const getOtherEntity = (definition: EventEntityDefinition): IOverviewButtonProps => ({
        linkTo: `/event/${eventPath}/${definition.id}`,
        number: definition.list.length || 0,
        title: definition.name,
        tileColor: eventData.eventInfo.styling.tileColor,
        infoCircle: (
            <InfoCircle
                icon={{
                    iconPrefix: 'far',
                    iconName: definition.icon
                }}
                bgColor={eventData.eventInfo.styling.circle.bgColor}
                iconColor={eventData.eventInfo.styling.circle.iconColor}
            />
        )
    });

    return {
        programme,
        information,
        map,
        getOtherEntity
    };
};
